<template>
  <div class="layout">
    <div class="max-left">
      <div class="left">
        <img :src="defaultImage" class="heard-img">
        <div class="user">{{ userinfo.userFname ? userinfo.userFname:userinfo.userName }}</div>
        <div class="phone">{{ userinfo.mobile }}</div>
        <div class="data" v-if="dataisactive" @click="datasubmit()">
          <img :src="dataimg" class="data-img">
          <div class="data-test" @click="routerdata()">数据统计</div>
        </div>
        <div class="dataactive" v-if="!dataisactive">
          <img :src="dataactive" alt="" class="data-img-1">
          <div class="data-test">数据统计</div>
        </div>
        <div class="account" v-if="accountisactive" @click="accountsubmit()" :style="dataisactive?'margin-top:100px' : 'margin-top:78px'">
          <img :src="account" class="data-img">
          <div class="data-test" @click="routeraccount()">账户管理</div>
        </div>
        <div class="accounttive" v-if="!accountisactive" >
          <img :src="accountactive" alt="" class="data-img-1">
          <div class="data-test">账户管理</div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="nav">
        <div class="nav-div" @click="withdrawfrombtn()">
          <img :src="withdrawfrom" class="nav-image">
          <div class="withdrawfrom" >退出</div>
        </div>
      </div>
      <div class="footer">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import defaultImage from '../assets/heard.png'
import dataimg from '../assets/data.png'
import account from '../assets/account.png'
import dataactive from '../assets/dataactive.png'
import accountactive from '../assets/accountactive.png'
import select from '../assets/select.png'
import withdrawfrom from '../assets/withdrawfrom.png'
import {homeuser} from "../utils/login";

export default {
  name: "home",
  data(){
    return{
      defaultImage,
      dataimg,
      account,
      dataactive,
      accountactive,
      select,
      withdrawfrom,
      dataisactive:true,
      accountisactive:true,
      keyIndex: '1',
      show:true,
      userinfo:{}
    }
  },
  created() {
    this.getinfo()
  },
  watch:{
    $route(to,from){
      console.log(to.path)
      if(to.path == "/home"){
        this.$router.push('/data').catch(err => { return err })
        this.dataisactive = false
        this.accountisactive = true
      }else if(to.path == "/data"){
        this.dataisactive = false
        this.accountisactive = true
      }else if(to.path == "/account"){
        this.dataisactive = true
        this.accountisactive = false
      }
    }
  },
  mounted () {
    //页面刷新处理
    if(window.name == ""){
      console.log(1)
      this.$router.push('/data').catch(err => { return err })
      this.dataisactive = false
      this.accountisactive = true
      window.name = "isReload";
    }else if(window.name == "isReload"){
      if(sessionStorage.getItem('signoutShow')==1){
        this.$router.push('/data').catch(err => { return err })
        this.dataisactive = false
        this.accountisactive = true
      }else{
        this.$router.push('/account').catch(err => { return err })
        this.dataisactive = true
        this.accountisactive = false
      }
    }
  },
  methods:{
    getinfo(){
      homeuser().then(res=>{
        this.userinfo = res
      }).catch(err=>{
        if(err.code == 16){
          sessionStorage.removeItem('token');
          this.$router.push('/login')
        }
      })
    },
    datasubmit(){
      this.show = true
      this.dataisactive = false
      this.accountisactive = true
    },
    accountsubmit(){
      this.show = false
      this.dataisactive = true
      this.accountisactive = false
    },
    routerdata(){
      sessionStorage.setItem("signoutShow",1);
      this.$router.push('/data').catch(err => { return err })
    },
    routeraccount(){
      sessionStorage.setItem("signoutShow",2);
      this.$router.push('/account').catch(err => { return err })
    },
    //退出
    withdrawfrombtn(){
      this.$confirm('此操作将退出登录返回登录页, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('userType')
        this.$message({
          type: 'success',
          message: '操作成功!'
        });
        this.$router.replace('/login')
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    }
  }
}
</script>
<style scoped>
  .layout .el-row{
    background: #65ADFF;
  }
  .layout .el-col-12{
    background: #65ADFF;
  }
</style>
<style lang='scss' scoped>
  .layout{
    width: 100%;
    height: 100%;
    .max-left{
      width: 320px;
      min-height: 100%;
    }
    .left{
      position: fixed;
      left: 0;
      width: 320px;
      min-height: 100%;
      opacity: 1;
      background: linear-gradient(180deg, #8ACBFF 0%, #3B8CFF 100%);
      text-align: center;
      .heard-img{
        width: 120px;
        height: 120px;
        margin: 100px 100px 0 100px;

      }
      .user{
        font-size: 32px;
        font-family: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #FFFFFF;
      }
      .phone{
        font-family: PingFang SC-Regular, PingFang SC;
        font-size: 24px;
        font-weight: 400;
        color: #FFFFFF;
      }
      .data{
        width: 167px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        margin-left: 97px;
        margin-top: 100px;
        .data-img{
          width: 30px;
          height: 30px;
          margin-top: 2px;
        }
        .data-test{
          font-size: 28px;
          font-family: PingFang SC-Bold, PingFang SC;
          font-weight: bold;
          color: #FFFFFF;
          a{
            font-size: 28px;
            font-family: PingFang SC-Bold, PingFang SC;
            font-weight: bold;
            color: #FFFFFF;
            text-decoration:none
          }
        }
      }
      .account{
        width: 167px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        margin-left: 97px;
        margin-top: 83px;
        .data-img{
          width: 30px;
          height: 30px;
          margin-top: 2px;
        }
        .data-test{
          font-size: 28px;
          font-family: PingFang SC-Bold, PingFang SC;
          font-weight: bold;
          color: #FFFFFF;
          a{
            font-size: 28px;
            font-family: PingFang SC-Bold, PingFang SC;
            font-weight: bold;
            color: #FFFFFF;
            text-decoration:none
          }
        }
      }
      .dataactive{
        width: 315px;
        height: 80px;
        background: #F5F7FA;
        border-radius: 40px 0px 0px 40px;
        opacity: 1;
        line-height: 80px;
        display: flex;
        align-items: center;
        margin-left: 66px;
        margin-top: 79px;
        .data-img-1{
          width: 30px;
          height: 30px;
          margin-left: 31px;
        }
        .data-test{
          font-size: 28px;
          font-family: PingFang SC-Bold, PingFang SC;
          margin-left: 25px;
          font-weight: bold;
          color: #5FA8FF;
          a{
            font-size: 28px;
            font-family: PingFang SC-Bold, PingFang SC;
            font-weight: bold;
            color: #5FA8FF;
            text-decoration:none
          }
        }
      }
      .accounttive{
        width: 315px;
        height: 80px;
        background: #F5F7FA;
        border-radius: 40px 0px 0px 40px;
        opacity: 1;
        line-height: 80px;
        display: flex;
        align-items: center;
        margin-left: 66px;
        margin-top: 78px;
        .data-img-1{
          width: 30px;
          height: 30px;
          margin-left: 31px;
        }
        .data-test{
          font-size: 28px;
          font-family: PingFang SC-Bold, PingFang SC;
          margin-left: 25px;
          font-weight: bold;
          color: #5FA8FF;
          a{
            font-size: 28px;
            font-family: PingFang SC-Bold, PingFang SC;
            font-weight: bold;
            color: #5FA8FF;
            text-decoration:none
          }
        }
      }
    }
    .main{
      width: calc(100% - 340px);
      .nav{
        position: fixed;
        left: 320px;
        top: 0px;
        height: 60px;
        width: 100%;
        background: #FFFFFF;
        box-shadow: 0px 3px 6px 1px rgba(158,169,199,0.3);
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        .nav-div{
          position: fixed;
          right: 33px;
          top:16px;
          display: flex;
          cursor: pointer;
          .nav-image{
            width: 29px;
            height: 29px;
            margin-right: 4px;
          }
          .withdrawfrom{
            font-size: 20px;
            font-family: PingFang SC-Bold, PingFang SC;
            font-weight: bold;
            color: #63ACFF;
          }
        }

      }
      .footer{
        position: fixed;
        left: 320px;
        top: 60px;
        //width: calc(100% - 320px);
        height: calc(100% - 60px);
        width: 100%;

        background: #F5F7FA;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home.vue